<template>
  <div class='container'>
    <nav class="work_nav">
      <ul>
        <li v-for="(nav,index) in navs" :key="index" >
          <a @click="changeTab(nav.name)" :class="{'active': nav.active}">{{ nav.title }}</a>
          <aside v-if="nav.num">{{ nav.num }}</aside>
        </li>
      </ul>
      <div class="filter">
        <el-select
                v-model="searchFormData.project_id"
                filterable
                placeholder="选择项目"
                style="width:100%"
                @change="selectProject"
              >
              <el-option
                v-for="item in projectDataList"
                :key="item.project_id"
                :label="item.name"
                :value="item.project_id"
              />
        </el-select>
        
        <el-select
              v-model="searchFormData.job_id" 
              placeholder="选择职位"
                clearable
                filterable
                style="width:100%"
                @change="selectJob"
              >
              <el-option
                v-for="item in jobDataList"
                :key="item.job_id"
                :label="item.title"
                :value="item.job_id"
              />
          </el-select>

          <el-button style="margin-right:10px" @click="setAudition">面试设置</el-button>
      </div>
    </nav>
    <div class="main">
      <div class="first" v-show="activeTab=='first'">
        <audition-list :params="searchFormData" ref="auditionList"></audition-list>
      </div>

      <div class="second" v-show="activeTab=='second'">
         <audition-result :params="searchFormData" ref="auditionResult"></audition-result>
      </div>
    </div>
  </div>
</template>

<script>
import { projectList} from "@/api/director/project/index.js";
import { jobList} from "@/api/director/job/index.js";

import auditionList from '@/views/director/audition/audition-list';
import auditionResult from '@/views/director/audition/audition-result';


export default {
  name: 'director-audition-index',
  components: {
    auditionList,auditionResult
  },
  data () {
    return {
      activeTab:'first',
      navs: [
        {
          title: "面试人员",
          name: 'director-audition-list',
          num: 0,
          active: true,
          tabName:'first',
        },
        {
          title: "面试结果",
          name: 'director-audition-result',
          num: 0,
          active: false,
          tabName:'second',
        },

      ],

      projectDataList:[],
      jobDataList:[],

      searchFormData:{
          project_id:"",
          job_id:""
        }
    }
  },

  mounted () {
    this.initProjectList();
   // this.initJobList();
  },
  created () {
    
    console.log(this.$route.name);

  },
  methods: {

    changeTab(val){
      var that=this;
      this.navs.forEach((item) => {
        item.active = (item.name == val? true : false);

        that.activeTab= (item.name == val? item.tabName : that.activeTab);
      });
    },

       //项目列表
   initProjectList(){
      var that = this;
      projectList({}).then((response) => {
        console.log('projectList',response);
        that.projectDataList = response.data;
        if(that.projectDataList&&that.projectDataList.length>0){
          this.searchFormData.project_id=this.projectDataList[0].project_id;

         
          this.$refs.auditionList.setParams(this.searchFormData.project_id,this.searchFormData.job_id);// 设置项目id 和 职位id
           this.$refs.auditionResult.setParams(this.searchFormData.project_id,this.searchFormData.job_id);

        }
       
      });
      
    },


    selectProject(e){
      console.log(e);
      this.searchFormData.project_id=e;
      this.searchFormData.job_id=''

      //project_id
      this.initJobList();

      this.$refs.auditionList.setParams(this.searchFormData.project_id,this.searchFormData.job_id);// 设置项目id 和 职位id
      this.$refs.auditionResult.setParams(this.searchFormData.project_id,this.searchFormData.job_id);




    },

    selectJob(e){
      console.log(e);
      this.searchFormData.job_id=e;
      
      this.$refs.auditionList.setParams(this.searchFormData.project_id,this.searchFormData.job_id);// 设置项目id 和 职位id
      this.$refs.auditionResult.setParams(this.searchFormData.project_id,this.searchFormData.job_id);

    },


 
    

    //职位列表
    initJobList(){
      var that = this;
      jobList(this.searchFormData).then((response) => {
        console.log('jobList',response);
        that.jobDataList = response.data;
      });
      
    },

    setAudition(){
      this.$router.push({ name: "director-audition-setting" });
    }




  }
}
</script>

<style lang="scss" scoped>
.work_nav {
  background: #d9d9d9;
  height: 60px;
  border-radius: 6px;
  overflow: hidden;
  margin-bottom: 19px;
  display: flex;
  justify-content: space-between;

  .filter{
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .el-select.el-select--small{
      margin-right: 10px;
    }

  }

  ul {
    display: flex;
    justify-content: flex-start;
    li {
      position: relative;
      a {
        padding: 0 24px;
        line-height: 60px;
        display: block;
        font-size: 22px;
        &.active {
          background-color: #4c71db;
          color: #fff;
        }
      }
    
      aside {
        width: 20px;
        height: 20px;
        position: absolute;
        top: 0;
        right: 0;
        color: #fff;
        background-color: #ff4e4e;
        border-radius: 10px;
        line-height: 20px;
        font-size: 12px;
        text-align: center;
      }
    }
  }
}
// .main {
// border-radius: 6px;
// box-shadow: 0px 0px 13px rgba(0, 0, 0, 0.15);
// padding: 29px 27px;
// }
</style>